import { render } from "./language-switch.vue?vue&type=template&id=3fcee862&scoped=true"
import script from "./language-switch.vue?vue&type=script&lang=js"
export * from "./language-switch.vue?vue&type=script&lang=js"

import "./language-switch.vue?vue&type=style&index=0&id=3fcee862&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcee862"]])

export default __exports__